import { STATUS_PROGRESSION } from "protocol-setup/helpers";

const TERMINAL_REQUEST_STATUSES = ["RETIRED", "CANCELED"];

export const getCanceledOrRetiredPanelStatus = ({ currentStatus, statusHistory, panelConfig, formPartType }) => {
  if (!TERMINAL_REQUEST_STATUSES.includes(currentStatus)) {
    return currentStatus;
  }

  const historyEntry = (statusHistory || []).find(
    (entry) => entry.toState === currentStatus
  );
  const fromStatus = historyEntry?.fromState;

  if (!fromStatus) {
    return currentStatus;
  }

  const visibleStatuses = panelConfig.map((panel) => panel.status);
  if (visibleStatuses.includes(fromStatus)) {
    return fromStatus;
  }

  const progression = STATUS_PROGRESSION[formPartType] || [];
  const fromStatusIndex = progression.indexOf(fromStatus);

  if (fromStatusIndex === -1) {
    return currentStatus;
  }

  for (let index = fromStatusIndex - 1; index >= 0; index -= 1) {
    const candidateStatus = progression[index];

    if (visibleStatuses.includes(candidateStatus)) {
      return candidateStatus;
    }
  }

  return currentStatus;
};

export const getDisplayRequestStatus = ({
  currentStatus,
  statusHistory,
  panelConfig,
  formPartType,
  setupCompletedProd,
  formsActivatedProd,
  optionalTrackingComments
}) => {
  const status = getCanceledOrRetiredPanelStatus({
    currentStatus,
    statusHistory,
    panelConfig,
    formPartType
  });

  if (
    !TERMINAL_REQUEST_STATUSES.includes(currentStatus) &&
    formPartType === "OPEN_RAVE" &&
    status === "COMPLETED" &&
    (setupCompletedProd || formsActivatedProd || optionalTrackingComments)
  ) {
    return "OPTIONAL_TRACKING";
  }

  return status;
};